import React, { lazy } from "react";
const Category = lazy(() =>
  import("../view/categoryCustom/category/Categorys")
);
const LookGoods = lazy(() =>
  import("../view/categoryCustom/lookGoods/LookGoods")
);
const SaleAnalysis = lazy(() =>
  import("../view/categoryCustom/saleAnalysis/SaleAnalysis")
);
const BrandSpecial = lazy(() =>
  import("../view/categoryCustom/category/BrandSpecial")
);
const salesDetails = lazy(() =>
  import("../view/categoryCustom/category/salesDetails")
);
const CustomAnalysis = lazy(() =>
  import("../view/categoryCustom/custom/CustomAnalysis")
);
const category = [
  // 展厅品类分析
  {
    path: "/categoryCustom/category",
    component: Category,
    id:"category"
  },
  // 查看款式
  {
    path: "/categoryCustom/lookGoods",
    component: LookGoods,
    id:"lookGoods"
  },
  // 展厅销售分析
  {
    path: "/categoryCustom/saleAnalysis",
    component:SaleAnalysis,
    id:"saleAnalysis"
  },
  // 品牌专项分析
  {
    path: "/categoryCustom/brandSpecial",
    component:BrandSpecial,
    id:"BrandSpecial"
  },
  // 品牌销售详情
  {
    path: "/categoryCustom/salesDetails",
    component:salesDetails,
    id:"salesDetails"
  },
  // 客户分析
  {
    path: "/categoryCustom/CustomAnalysis",
    component:CustomAnalysis,
    id:"CustomAnalysis"
  },
];
export default category;
